module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASxJREFUeNrMl1EKgzAMQJv8CrvA8HN/fgo7gOAh/PNk/u0QggeQ+ekNZBcY7H+pRCgbc20a0UColKZP0qRpIE3PF2PMjTQnHUnraXoMRlGIYfduSDNSu3cFNHln6CJP0pLgvRL0SkNLenKmB/yAGl7QssEWUCs5snuNNnwFamW04Jrdqwb/A7WsGjmQSi24B9TGzwCBBr0CdN4DpIYx0C+wFC6xgdi/l3oJYs6Lv0VHAxHB8uIxkQQjRKaHkWYAKORmMNQb7MC7H65dXF/4Fhc0OwkGujpZWZaEXK/HDK4t0wkjLpCCVVTVjnNl7lIkdimLuzwENKChcODHdqcBDckI5Be+GtQK26w9IBvktkIN6gnPkHsZVagHfG5hKgc+hpS2AHjhdCxz0/YWYADm+/5pFfa81gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./img/cancel-button.png
// module id = 486
// module chunks = 0